import Vue from 'vue'
// 引入Vant 的组件
import '@/assets/style/structure.less'
import '@/assets/style/tag-types.less'

import {
  CellGroup,
  Image,
  Icon,
  Tag,
  Picker,
  Button,
  Form,
  Field,
  Col,
  Row,
  DropdownMenu,
  DropdownItem,
  Toast,
  Loading,
  Dialog,
  Notify,
  List,
  Cell,
  Empty,
  Popup,
  Step,
  Steps,
  Overlay
} from 'vant'
Vue.use(Step)
Vue.use(Steps)
Vue.use(Overlay)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(Button)
Vue.use(Form)
Vue.use(Field)
Vue.use(Col)
Vue.use(Row)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Toast)
Vue.use(Loading)
Vue.use(Dialog)
Vue.use(Notify)
Vue.use(List)
Vue.use(Cell)
Vue.use(Empty)
Vue.use(Tag)
Vue.use(Icon)
Vue.use(Image)
Vue.use(CellGroup)
